import { z } from "zod";
export const costIncurredPayloadSchema = z
    .object({
    jobId: z.string().min(1).optional(),
    commandRunId: z.string().min(1).optional(),
    usd: z.number().min(0),
    source: z.string().min(1),
})
    .refine((p) => p.jobId !== undefined || p.commandRunId !== undefined, {
    message: "CostIncurred requires jobId or commandRunId",
    path: ["jobId"],
});
export const costCapExceededPayloadSchema = z
    .object({
    jobId: z.string().min(1).optional(),
    commandRunId: z.string().min(1).optional(),
    currentUsd: z.number().min(0),
    capUsd: z.number().min(0),
})
    .refine((p) => p.jobId !== undefined || p.commandRunId !== undefined, {
    message: "CostCapExceeded requires jobId or commandRunId",
    path: ["jobId"],
});
//# sourceMappingURL=cost.js.map